"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTvaRatioByCountry = void 0;
var getTvaRatioByCountry = exports.getTvaRatioByCountry = function getTvaRatioByCountry() {
  var _tvaRates$country$toU;
  var country = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'FR';
  var DEFAULT_TVA_RATE = 0.20;
  var tvaRates = {
    FR: 0.20,
    IT: 0.22,
    ES: 0.21,
    PT: 0.23,
    DE: 0.19,
    BE: 0.06,
    UK: 0.20,
    AT: 0.20,
    BG: 0.20,
    CY: 0.19,
    HR: 0.25,
    DK: 0.25,
    EE: 0.22,
    FI: 0.24,
    GR: 0.24,
    HU: 0.27,
    IE: 0.23,
    LV: 0.21,
    LT: 0.21,
    LU: 0.17,
    MT: 0.18,
    NL: 0.21,
    PL: 0.23,
    RO: 0.19,
    SK: 0.23,
    SI: 0.22,
    SE: 0.12,
    CH: 0.08,
    CZ: 0.21,
    LI: 0.08,
    NO: 0.25
  };
  return (_tvaRates$country$toU = tvaRates[country.toUpperCase()]) !== null && _tvaRates$country$toU !== void 0 ? _tvaRates$country$toU : DEFAULT_TVA_RATE;
};